export default __webpack_public_path__ + "static/media/instagram.3e09e61a.svg";